
/*
============================================================
BEL LMT — IMAGE PROTECTION
============================================================

PURPOSE
Discourages casual copying of product images by disabling:
1. Right-click context menus on images.
2. Dragging images to the desktop or another location.

This is a deterrent only. It does not prevent screenshots,
browser developer tools or direct access to image URLs.

SHOPIFY THEME
Originally implemented in Fabric 3.0.0.

FILE LOCATION
assets/bellmt-image-protection.js

IMPORTANT — WHEN UPDATING THE SHOPIFY THEME

Custom theme files and modifications may not carry over
automatically when installing a new theme version.

After updating the theme:

1. Check whether this JavaScript file exists in the new
   theme's Assets folder.

2. If missing, copy bellmt-image-protection.js from the
   previous theme into the new theme's Assets folder.

3. Open the new theme's layout/theme.liquid file.

4. Add the following line immediately before </body>
   if it is not already present:

   <script src="{{ 'bellmt-image-protection.js' | asset_url }}" defer></script>

5. Save the changes.

6. Test a product page:
   - Right-clicking product images should be blocked.
   - Dragging product images should be blocked.
   - Product gallery and zoom should still work.

7. Only publish the updated theme once testing is complete.

Do not use Shopify's script_tag Liquid filter because
it generates a parser-blocking script.

============================================================
*/

// Prevent right-clicking on images.
document.addEventListener('contextmenu', function(event) {
  if (event.target.closest('main img')) {
    event.preventDefault();
  }
});

// Prevent dragging images.
document.addEventListener('dragstart', function(event) {
  if (event.target.closest('main img')) {
    event.preventDefault();
  }
});

